'use client';
import Link from "next/link";
import { FaWhatsapp } from "react-icons/fa";
import { motion, useInView } from 'framer-motion';
import { getCdnUrl } from '@/utils/cdn';
import { useRef } from 'react';

export default function QualitySection() {
	const ref = useRef(null);
	const isInView = useInView(ref, { once: true, margin: '-200px' });

	const fromRightVariants = {
		hidden: { opacity: 0, x: 100 },
		visible: { opacity: 1, x: 0 },
	};

	const fromLeftVariants = {
		hidden: { opacity: 0, x: -100 },
		visible: { opacity: 1, x: 0 },
	};

	return (
		<section ref={ref} className="relative h-full px-0 bg-custom-gradient overflow-hidden  pt-1">
			{/* Marquee de texto ao fundo */ }
			<div className="absolute inset-0 pointer-events-none select-none">
				<div className="absolute md:top-[45%] top-[95%] z-10 transform -translate-y-1/2 whitespace-nowrap animate-marquee-slow text-[8vw] 2xl:text-[12vw] tracking-tight text-black uppercase">
					Qualidade, segurança e acessibilidade
				</div>
			</div>

			{/* Conteúdo centralizado (acima da curva) */}
			<div className="relative z-10 mx-auto max-w-7xl md:w-[60%] w-[75%] ">
				<div className=" mb-6 sm:mb-10">
					<p className="mt-16 md:mt-8 text-3xl md:text-4xl  font-bold text-white md:pr-48 ">Um novo capítulo da sua história começa agora</p>
					<p className=" text-white/90 text-md md:text-xl font-light mt-4">Aqui compreendemos as necessidades e desafios da busca por imóveis de qualidade e empreendimentos, que transcendem o simples ato de morar, incorporando áreas de lazer e localizações privilegiadas.</p>

				</div>


			</div>
			<div className="flex justify-center relative pb-16 md:mt-20 mt-28">
				{/* Balão 1 - Top Left */}
				<motion.div
					variants={fromRightVariants}
					initial="hidden"
					animate={isInView ? 'visible' : 'hidden'}
					transition={{ duration: 0.5, delay: 0.2 }}
					className="relative w-0 md:top-[160px] md:right-[250px] top-[130px] -right-[200px] z-30"
				>
					<div className="bg-[#D5F6D5] rounded-xl sm:rounded-3xl px-2 py-3 sm:px-4 sm:py-2 md:px-6 md:py-4 shadow-custom md:w-48 w-32">
						<p className="text-xs sm:text-sm md:text-base text-center font-light text-gray-800">Área de lazer completa</p>
					</div>
				</motion.div>

				{/* Balão 2 - Bottom Left */}
				<motion.div
					variants={fromRightVariants}
					initial="hidden"
					animate={isInView ? 'visible' : 'hidden'}
					transition={{ duration: 0.5, delay: 0.4 }}
					className="relative w-0 md:top-[400px] md:right-[140px] right-[50px] top-[210px] z-30"
				>
					<div className="bg-[#D5F6D5] rounded-xl sm:rounded-3xl px-2 py-3 sm:px-4 sm:py-2 md:px-6 md:py-4 shadow-custom md:w-48 w-28">
						<p className="text-xs sm:text-sm md:text-base text-center font-light text-gray-800">Localização privilegiada</p>
					</div>
				</motion.div>

				{/* Celular central */}
				<div className="relative z-20">
					<div className="relative w-[70vw] h-[420px] md:w-[330px] md:h-[600px] rounded-[24px] sm:rounded-[36px] bg-black/20 ring-4 md:ring-[12px] ring-black shadow-2xl overflow-hidden">

						<video
							autoPlay
							muted
							loop
							playsInline
							className="absolute inset-0 w-full h-full object-cover rounded-[24px] sm:rounded-[36px]"
						>
							<source src={getCdnUrl("/videos/qualidade.mp4")} type="video/mp4" />
							Seu navegador não suporta vídeos.
						</video>
					</div>
				</div>

				{/* Balão 3 - Top Right */}
				<div className="relative w-0 md:top-[160px] top-[250px] md:right-0 right-[90px] z-30">
					<Link href="https://api.whatsapp.com/send/?phone=5532998809292&text=Oi%21+Vim+do+site+da+Forbli.+Gostaria+de+mais+informa%C3%A7%C3%B5es.+Pode+me+ajudar%3F&type=phone_number&app_absent=0" target="_blank">
						<div className="relative bg-[#54D454] rounded-xl sm:rounded-3xl px-6 py-3  md:px-8 md:py-9 shadow-custom md:w-64 w-36 flex justify-center items-center ">
							{/* Ícone WhatsApp outline */}
							<FaWhatsapp className="text-white md:text-6xl text-5xl w-20" />
							<p className="text-xs sm:text-sm md:text-base text-center font-bold text-white">
								Converse com um especialista
							</p>

							{/* Cauda do balão de fala (maior) */}
							<div className="absolute -bottom-3 left-6 sm:left-10 w-3 h-3 sm:w-10 sm:h-10 bg-[#54D454] transform rotate-45 md:block hidden"></div>
						</div>
					</Link>

				</div>

				{/* Balão 4 - Bottom Right */}
				<motion.div
					variants={fromLeftVariants}
					initial="hidden"
					animate={isInView ? 'visible' : 'hidden'}
					transition={{ duration: 0.5, delay: 0.6 }}
					className="relative w-0 md:top-[500px] top-[310px] md:left-[15px] -left-[310px] z-30"
				>
					<div className="bg-[#D5F6D5] rounded-xl sm:rounded-[40px] px-2 py-3 sm:px-4 sm:py-2 md:px-6 md:py-4 shadow-custom md:w-44 w-32">
						<p className="text-xs sm:text-sm md:text-base text-center font-light text-gray-800">Ideal para o conforto da sua família</p>
					</div>
				</motion.div>
			</div>
			{/* Curva inferior mais acentuada via elipse, atrás do conteúdo */}
			<div
				aria-hidden
				className="absolute inset-x-0 bottom-0 h-32 md:h-40 pointer-events-none z-0"
				style={{ background: '#ffffff', clipPath: 'ellipse(51% 130% at 50% 130%)' }}
			/>
		</section>
	);
}